<template>
  <div>
    <!-- Banner Starts -->
    <section class="banner">
      <div class="row">
        <div class="col-lg-12">
           <div class="owl-banner owl-carousel owl-theme" ref="carousel">
             <div class="item"><img src="http://en.sc.ruc.edu.cn/static/images/banner4.jpg"></div>
             <div class="item"><img src="http://en.sc.ruc.edu.cn/static/images/banner3.jpg"></div>

             <div class="item"><img src="http://en.sc.ruc.edu.cn/static/images/banner5.jpg"></div>
<!--             <div class="item"><img src="static/assets/images/banner6.jpg"></div>-->
             <div class="item"><img src="http://en.sc.ruc.edu.cn/static/images/banner7.jpg"></div>
             <div class="item"><img src="http://en.sc.ruc.edu.cn/static/images/banner8.JPG"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- Banner End -->


    <div class="home2">
        <div class="w-wrap xr-now xr-act">
          <div class="unit xr-cur">
            <div class="tit">
              <div class="t_title">News</div>
              <div class="pad">
                <router-link to="/blog">
                    <a class="t_more b red">more</a>
                </router-link>
              </div>
            </div>
            <div class="home2-content">
              <div class="home2-content-box">
                <div id="home2-line" class="home2-content-box-line "></div>
                <div class="home2-content-box-item home2-content-box-top  wow slideInLeft" @click="goTo('1')">
                  <div class="home2-content-box-item-lf">
                    <div class="home2-content-box-item-lf-img">
                      <img src="http://en.sc.ruc.edu.cn/static/images/home/news.png" alt="feature">
                    </div>
                  </div>
                  <div class="home2-content-box-item-rt">
                    <div class="home2-content-box-item-text">
<!--                      <h1>'Cambria Math'</h1>-->
                      <h4>
                        The inaugural Suzhou Forum on Humanistic Economics and the unveiling ceremony of the Suzhou Research Center for Humanistic Economics of Renmin University of China was held at the Suzhou campus on December 24, 2023.

                      </h4>
                    </div>
                  </div>
                </div>
                <div class="home2-content-box-item home2-content-box-bot  wow slideInRight" @click="goTo('2')">
                  <div class="home2-content-box-item-lf">
                    <div class="home2-content-box-item-text">
<!--                      <h1>The 10th Asian Policy</h1>-->
                      <h4>The Tenth Policy Forum in Asia was held at Suzhou Campus, with the theme: challenges and governance in the digital age.</h4>
                    </div>
                  </div>
                  <div class="home2-content-box-item-rt">
                    <div class="home2-content-box-item-rt-img">
                      <img src="http://en.sc.ruc.edu.cn/static/images/home/news1.png" alt="feature">
                    </div>
                  </div>
                </div>

                <div class="home2-more-box wow bounceInUp" data-wow-delay="0.7s" >
                  <div class="home2-more-box-content">
                    <router-link to="/blog">
                        <a class="home2-more-box-content-top t_more">More</a>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div class="home2-content-mobile">
              <div class="ul" style="min-width:10px;min-height:10px;">
                <div class="li li1">
                  <a @click="goTo('1')" target="_blank" class="link">
                    <div class="img"><img src="http://en.sc.ruc.edu.cn/static/images/home/news.png" alt="" title="" class="i"></div>
                    <div class="cont">
<!--                      <div class="date">-->
<!--                        <div class="b">27</div>-->
<!--                        <div class="m">Jan</div>-->
<!--                      </div>-->
                      <div class="t">
<!--                        <h1>Gold Award!</h1>-->
                        <h4>
                          The inaugural Suzhou Forum on Humanistic Economics and the unveiling ceremony of the Suzhou Research Center for Humanistic Economics of Renmin University of China was held at the Suzhou campus on December 24, 2023.
                        </h4>

                      </div>
                    </div>
                  </a>
                </div>
                <div class="li li2">
                  <a @click="goTo('2')" target="_blank" class="link">
                    <div class="img"><img src="http://en.sc.ruc.edu.cn/static/images/home/news1.png" alt="" title="" class="i"></div>
                    <div class="cont">
<!--                      <div class="date">-->
<!--                        <div class="b">24</div>-->
<!--                        <div class="m">Jan</div>-->
<!--                      </div>-->
                      <div class="t">
<!--                        <h1>The 10th Asian Policy</h1>-->
                        <h4>The Tenth Policy Forum in Asia was held at Suzhou Campus, with the theme: challenges and governance in the digital age.</h4>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
    </div>

    <div class="home5">
      <div class="tit">
        <div class="t_title">Gallery</div>
        <div class="pad">
          <a style="cursor: pointer;color: #fff;" @click="router('/PricingPlan')" class="t_more b red">more</a>
        </div>
        <div class="slick-nav"></div>
      </div>
      <div class="slick-big-box" style="min-width:10px;min-height:10px;">
        <div class="slick-mod">


              <div class="employee-slider owl-carousel owl-theme">

                <div class="single-slide">
                  <div class="slide-img ">
                    <img src="http://en.sc.ruc.edu.cn/static/images/Gallery/3.jpg" alt="employee">
                  </div>
<!--                  <div class="slide-text align-self-center">-->
<!--                    <p>-->
<!--                      Suzhou Campus held "Wu Yuzhang in the Work-Study Movement in France" Chinese and foreign youth theme thought salon-->
<!--                    </p>-->
<!--                  </div>-->
                </div>

                <div class="single-slide">
                  <div class="slide-img ">
                    <img src="http://en.sc.ruc.edu.cn/static/images/Gallery/6.png" alt="employee">
                  </div>
<!--                  <div class="slide-text align-self-center">-->
<!--                    <p>-->
<!--                      Far-sighted youth visit Zhouzhuang ancient Town to experience the long history of Chinese civilization-->
<!--                    </p>-->
<!--                  </div>-->
                </div>
                <div class="single-slide">
                  <div class="slide-img ">
                    <img src="http://en.sc.ruc.edu.cn/static/images/Gallery/10.jpg" alt="employee">
                  </div>
                </div>
                <div class="single-slide">
                  <div class="slide-img ">
                    <img src="http://en.sc.ruc.edu.cn/static/images/Gallery/11.jpg" alt="employee">
                  </div>
                </div>
                <div class="single-slide">
                  <div class="slide-img ">
                    <img src="http://en.sc.ruc.edu.cn/static/images/Gallery/12.jpg" alt="employee">
                  </div>
                </div>
                <div class="single-slide">
                  <div class="slide-img ">
                    <img src="http://en.sc.ruc.edu.cn/static/images/Gallery/13.jpg" alt="employee">
                  </div>
                </div>

              </div>

        </div>
      </div>
      <div class="slick-snav"></div>
    </div>
    <!-- Employee Area End -->

  </div>
</template>

<script>
import $ from 'jquery'
import router from '../router'
window.jQuery = $
window.$ = $
export default {
  name: 'home',
  methods: {
    goTo (id) {
      router.push({
        path: '/blogDetails',
        query: {
          id: id
        }
      })
    },
    router (url) {
      router.push({
        path: url
      })
    },
    installOwlCarousel: function () {
        // my options
      let owl = window.$('.owl-banner')
      let owl2 = window.$('.employee-slider')
      owl.owlCarousel({
        loop: true,
        autoplay: true,
        dots: true,
        responsiveRefreshRate: 100,
        autoHeight: true,
        lazyLoad: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        items: 1,
        margin: 0
      })
      owl.trigger('refresh.owl.carousel')
      owl2.owlCarousel({
        loop: true,
        dots: false,
        nav: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        navigation: true,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
            stagePadding: 0,
            margin: 0
          },
          576: {
            items: 1,
            margin: 0,
            stagePadding: 0
          },
          760: {
            items: 1,
            stagePadding: 0,
            margin: 0
          },
          1200: {
            margin: 180,
            stagePadding: 320,
            items: 2
          }
        }
      })
    }
  },
  mounted () {
    setTimeout(() => {
      this.installOwlCarousel()
    }, 500)
  }
}
</script>
<style scoped>
.owl-carousel .item img {
  width: 100%;
  height: auto;
}
/* 全屏样式 */
.owl-carousel-fullscreen .owl-item {
  height: 100vh;
 
}
</style>



// WEBPACK FOOTER //
// Home.vue?b13f58c6